import { useNavigate } from "react-router-dom";
import { ReactComponent as BlackVatugIcon } from "../../Asset/black.svg"; 
import useCustomerForm from "../../Lib/useCustomerForm";
import useFetchFundingSources from "../../Lib/useFetchFundingSources";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useState, useRef, useEffect } from "react";
import "./Customeractivation.css";

const Customeractivationpage1 = () => {
  const { formDatas, handleInputChange, handleFormSubmit } = useCustomerForm();
  const navigate = useNavigate();
  const { data: fundingSourcesData, isLoading: isFetchingFundingSources } = useFetchFundingSources();
  
  // State to store the full phone numbers with country codes
  const [phoneNumber, setPhoneNumber] = useState('');
  const [additionalPhoneNumber, setAdditionalPhoneNumber] = useState('');
  
  // State for validation errors
  const [phoneError, setPhoneError] = useState('');
  const [additionalPhoneError, setAdditionalPhoneError] = useState('');
  
  // State for custom funding source dropdown
  const [isFundingSourceOpen, setIsFundingSourceOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const fundingSourceRef = useRef(null);

  // Validation function for Nigerian phone numbers
  const validateNigerianPhone = (phoneValue) => {
    // Remove all non-digit characters
    const cleanValue = phoneValue.replace(/[\s\D]/g, '');
    
    // Check if it starts with 234 (Nigeria country code) and has exactly 13 digits total (234 + 11 digits)
    if (cleanValue.startsWith('234') && cleanValue.length === 13) {
      return { isValid: true, error: '' };
    }
    
    // Check if it's just 11 digits (without country code)
    if (cleanValue.length === 11 && !cleanValue.startsWith('234')) {
      return { isValid: true, error: '' };
    }
    
    // Invalid format - no error message
    return { 
      isValid: false, 
      error: '' 
    };
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (fundingSourceRef.current && !fundingSourceRef.current.contains(event.target)) {
        setIsFundingSourceOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Handle phone input changes
  const handlePhoneChange = (value, country) => {
    console.log("Phone input value:", value);
    console.log("Phone input country:", country);
    
    // Validate the phone number
    const validation = validateNigerianPhone(value);
    
    if (validation.isValid) {
      setPhoneError('');
      setPhoneNumber(value);
      console.log("Phone value:", value);
      console.log("Phone value length:", value.length);
      handleInputChange({
        target: {
          name: 'phoneNumber',
          value: value
        }
      });
    } else {
      setPhoneError(validation.error);
      setPhoneNumber(value);
    }
    
    // Store the selected country for page 2
    handleInputChange({
      target: {
        name: 'selectedCountry',
        value: country.name
      }
    });
  };

  // Handle additional phone input changes
  const handleAdditionalPhoneChange = (value, country) => {
    console.log("Additional phone input value:", value);
    console.log("Additional phone input country:", country);
    
    // Validate the phone number
    const validation = validateNigerianPhone(value);
    
    if (validation.isValid) {
      setAdditionalPhoneError('');
      setAdditionalPhoneNumber(value);
      console.log("Additional phone value:", value);
      console.log("Additional phone value length:", value.length);
      handleInputChange({
        target: {
          name: 'additionalPhoneNumber',
          value: value
        }
      });
    } else {
      setAdditionalPhoneError(validation.error);
      setAdditionalPhoneNumber(value);
    }
    
    // Store the selected country for page 2 (if not already set)
    if (!formDatas.selectedCountry) {
      handleInputChange({
        target: {
          name: 'selectedCountry',
          value: country.name
        }
      });
    }
  };

  // Handle funding source selection
  const handleFundingSourceSelect = (source) => {
    // Update form data
    handleInputChange({
      target: {
        name: 'fundingSource',
        value: source
      }
    });
    
    // Close dropdown and reset search
    setIsFundingSourceOpen(false);
    setSearchTerm('');
    
    // Force state update
    setTimeout(() => {
      setIsFundingSourceOpen(false);
    }, 0);
  };

  // Toggle funding source dropdown
  const toggleFundingSourceDropdown = () => {
    setIsFundingSourceOpen(!isFundingSourceOpen);
  };

  // Filter funding sources based on search term
  const filteredFundingSources = Array.isArray(fundingSourcesData?.data) 
    ? fundingSourcesData.data.filter(source => 
        source.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : [];

  return (
    <div className="customer-active-container">
      <div className="wrap">
      <div className="header">
        <button onClick={() => navigate("/typeofupdate")}>Back</button>
        <BlackVatugIcon onClick={() => navigate("/")}/>
        <button className="finished">Next</button>
      </div>
      </div>
      <form onSubmit={handleFormSubmit}>
        <h2>Company Details</h2>
        <label>
          Company Name
          <input
            type="text"
            placeholder="Enter Company Name"
            name="companyName"
            value={formDatas.companyName}
            onChange={handleInputChange}
            required
          />
        </label>

        <label>
          Years in Operation
          <input
            type="text"
            placeholder="Years in Operation"
            name="yearsInOperation"
            value={formDatas.yearsInOperation}
            onChange={handleInputChange}
            required
          />
        </label>

        <label>
          Registration Number
          <input
            type="text"
            placeholder="Registration Number"
            name="registrationNumber"
            value={formDatas.registrationNumber}
            onChange={handleInputChange}
            required
          />
        </label>

        <label>
          Funding Source
          {isFetchingFundingSources ? (
           <Skeleton height={40} width="100%" />
          ) : (
            <div className="custom-select-container" ref={fundingSourceRef}>
              <button 
                type="button"
                className="custom-select-button"
                onClick={toggleFundingSourceDropdown}
                required
              >
                {formDatas.fundingSource || "Choose Funding Source"}
              </button>
              {isFundingSourceOpen && (
                <div className="custom-select-dropdown show">
                  <div className="custom-select-search">
                    <input
                      type="text"
                      placeholder="Search funding sources..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                  {filteredFundingSources.length > 0 ? (
                    filteredFundingSources.map((source, index) => (
                      <div
                        key={index}
                        className={`custom-select-option ${formDatas.fundingSource === source ? 'selected' : ''}`}
                        onClick={() => handleFundingSourceSelect(source)}
                      >
                        {source}
                      </div>
                    ))
                  ) : (
                    <div className="custom-select-option">No funding sources available</div>
                  )}
                </div>
              )}
            </div>
          )}
        </label>

        <label>
          Website
          <input
            type="text"
            placeholder="Website"
            name="website"
            value={formDatas.website}
            onChange={handleInputChange}
            required
          />
        </label>

        <label>
          Phone Number
          <PhoneInput
            country={'ng'}
            value={phoneNumber}
            onChange={handlePhoneChange}
            disableFormatting={false}
            disableCountryCode={false}
            inputProps={{
              name: 'phoneNumber',
              required: true,
              autoFocus: true,
              placeholder: 'Enter phone number'
            }}
            containerClass="phone-input-container"
            inputClass="phone-input"
            buttonClass="phone-input-button"
            dropdownClass="phone-input-dropdown"
            searchClass="phone-input-search"
            enableSearch={true}
            disableDropdown={false}
          />
          {phoneError && <span className="error-message">{phoneError}</span>}
        </label>

        <label>
          Additional Phone Number
          <PhoneInput
            country={'ng'}
            value={additionalPhoneNumber}
            onChange={handleAdditionalPhoneChange}
            disableFormatting={false}
            disableCountryCode={false}
            inputProps={{
              name: 'additionalPhoneNumber',
              required: false,
              placeholder: 'Enter additional phone number'
            }}
            containerClass="phone-input-container"
            inputClass="phone-input"
            buttonClass="phone-input-button"
            dropdownClass="phone-input-dropdown"
            searchClass="phone-input-search"
            enableSearch={true}
            disableDropdown={false}
          />
          {additionalPhoneError && <span className="error-message">{additionalPhoneError}</span>}
        </label>

        <button type="submit">Next</button>
      </form>
    </div>
  );
};

export default Customeractivationpage1;
